import { render, staticRenderFns } from "./SchoolReportingData.vue?vue&type=template&id=2d4198b7"
import script from "./SchoolReportingData.vue?vue&type=script&lang=js"
export * from "./SchoolReportingData.vue?vue&type=script&lang=js"
import style0 from "./SchoolReportingData.vue?vue&type=style&index=0&id=2d4198b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports